import ReloadOutlined from '@ant-design/icons/lib/icons/ReloadOutlined'
import { Button } from 'antd'
import { FC } from 'react'
import { DataSourceItem } from '../../../shipments-page'
import { useRepeatOrder } from '../../../hooks/use-repeat-order'

interface CreateCalculationProps {
    selectedRows: DataSourceItem[]
}

const CreateCalculation: FC<CreateCalculationProps> = ({ selectedRows }) => {
    const { repeatOrder, isLoading } = useRepeatOrder()

    return (
        <Button
            title={'Повторить заказ'}
            style={{ margin: '0 auto', display: 'block' }}
            size='small'
            icon={<ReloadOutlined />}
            color='green'
            variant={'solid'}
            onClick={() => repeatOrder(selectedRows)}
            loading={isLoading}
        />
    )
}

export default CreateCalculation
